// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateIsValidDealer = (state, action) => action.isValidDealer;

export default (state = getDefaultState().isValidDealer, action) => {

    const actionTypes = {
        [actions.UPDATE_PIP_SEARCH_IS_VALID_DEALER]: updateIsValidDealer
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-search/reducers/is-valid-dealer.js